import { Container } from '@/components/ui/template/Container'

export function TopSection() {
    return (
        <Container>
            <Container.BackgroundImage
                src="/images/harvest-bg.webp"
                sizes="100vw"
                alt="Harvest BG"
            />
            <Container.Content className="flex flex-col justify-center items-center relative text-center px-6 pt-[140px] md:pt-[140px] pb-12 lg:pt-36 lg:pb-20 lg:px-0 gap-3 lg:gap-0 text-neutral md:min-h-[200px] lg:min-h-[300px] leading-none uppercase">
                <h2 className="text-[3.5rem] md:text-[3.75rem] lg:text-[6rem] leading-none">Mr. PEPPER</h2>
            </Container.Content>
        </Container>
    )
}
